/** Ordem do Kanban (espelho de Candidatura.ETAPAS_KANBAN). */
export const ETAPAS_KANBAN = [
  'novo',
  'triagem',
  'entrevista_rh',
  'juridico',
  'prova_tecnica',
  'entrevista_gestor',
  'proposta',
  'aprovado',
  'admissao',
] as const

export const ETAPA_LABELS: Record<string, string> = {
  novo: 'Novo',
  triagem: 'Triagem',
  entrevista_rh: 'Entrevista RH',
  juridico: 'Jurídico',
  prova_tecnica: 'Prova técnica',
  entrevista_gestor: 'Entrevista gestor',
  proposta: 'Proposta',
  aprovado: 'Aprovado',
  admissao: 'Admissão',
  contratado: 'Contratado',
  reprovado: 'Reprovado',
  desistiu: 'Desistiu',
}

export const ETAPA_COLORS: Record<string, string> = {
  novo: '#2563eb',
  triagem: '#0891b2',
  entrevista_rh: '#7c3aed',
  juridico: '#b45309',
  prova_tecnica: '#db2777',
  entrevista_gestor: '#16a34a',
  proposta: '#ca8a04',
  aprovado: '#00d931',
  admissao: '#000070',
  reprovado: '#94a3b8',
  desistiu: '#64748b',
}

export const STATUS_LABELS: Record<string, string> = {
  rascunho: 'Rascunho',
  aberta: 'Aberta',
  pausada: 'Pausada',
  fechada: 'Fechada',
}

export const PRIORIDADE_LABELS: Record<string, string> = {
  baixa: 'Baixa',
  media: 'Média',
  alta: 'Alta',
  urgente: 'Urgente',
}
